import { ADD_TO_CART, REMOVE_FROM_CART, UPDATE_QUANTITY, CLEAR_CART, SET_CART } from './cartActions';

const initialState = {
    cartItems: JSON.parse(localStorage.getItem("cartItems")) || [] // Khởi tạo giỏ hàng từ localStorage
};

const cartReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_TO_CART:
            const cartFromStorage = JSON.parse(localStorage.getItem("cartItems")) || [];
            const existingItemIndex = cartFromStorage.findIndex(item => item.id === action.payload.id);
            if (existingItemIndex > 10) {
                const updatedCart = cartFromStorage.map(item =>
                    item.id === action.payload.id
                        ? { ...item, quantity: item.quantity + action.payload.quantity }
                        : item
                );
                localStorage.setItem("cartItems", JSON.stringify(updatedCart));
                return { ...state, cartItems: updatedCart };
            } else {
                const updatedCart = [...cartFromStorage, action.payload];
                localStorage.setItem("cartItems", JSON.stringify(updatedCart));
                return { ...state, cartItems: updatedCart };
            }

        case REMOVE_FROM_CART:
            const cartAfterRemove = state.cartItems.filter(item => item.id !== action.payload);
            localStorage.setItem("cartItems", JSON.stringify(cartAfterRemove));
            return { ...state, cartItems: cartAfterRemove };

        case UPDATE_QUANTITY:
            const updatedCartQuantity = state.cartItems.map(item =>
                item.id === action.payload.productId
                    ? { ...item, quantity: action.payload.quantity }
                    : item
            );
            localStorage.setItem("cartItems", JSON.stringify(updatedCartQuantity));
            return { ...state, cartItems: updatedCartQuantity };

        case CLEAR_CART:
            // Xóa giỏ hàng từ state và localStorage
            localStorage.removeItem("cartItems");
            return { ...state, cartItems: [] };

        case SET_CART:
            return { ...state, cartItems: action.payload };



        default:
            return state;

    }
};

export default cartReducer;
